import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Typography } from "@mui/material";
import {useNavigate} from "react-router-dom";
import '../../../style/SalesMarketing.css';
import { useTranslation } from "react-i18next";
import { CheckCircleRounded, CloseRounded, ReportProblemRounded } from "@mui/icons-material";
import {useHasScope} from "../../../../../config/globalConfig";

interface ProductCodeCreateModalProps {
    open: boolean,
    setOpen: Function,
    isSuccess: boolean,
    createdProductCode?: string
}

const ProductCodeCreateModal = ({ open, setOpen, isSuccess, createdProductCode }: ProductCodeCreateModalProps) => {
    const { t } = useTranslation(['salesmarketing', 'translation']);
    const navigate = useNavigate();
    const hasScope = useHasScope;

    return (
        <>
            <Dialog open={open} maxWidth={false}>
                <DialogTitle sx={{borderBottom:'0px'}}>
                    <Grid container item xs={12}>
                        <Grid item xs={1}>
                            {isSuccess ?
                                <CheckCircleRounded color={"success"} /> : <ReportProblemRounded color={"error"} />
                            }
                        </Grid>
                        <Grid item xs={10}>
                            <Typography color="primary" className="ModalTitle">
                            {isSuccess ?
                                (t('salesmarketing:product.createModal.successTitle') + createdProductCode) : t('salesmarketing:product.createModal.errorTitle')
                            }
                            </Typography>
                        </Grid>
                        <Grid item xs={1}>
                            <IconButton sx={{position: 'absolute', right: 16, top: 12,}} onClick={() => { setOpen(false) }}>
                                <CloseRounded />
                            </IconButton>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent className="ModalBody">
                    <Grid container spacing={2} sx={{padding: "15px"}} alignItems={"center"}>
                        <Grid item>
                            <Typography color={"primary"} variant={"body1"} style={{whiteSpace: "pre-line"}}>
                            {t('salesmarketing:product.createModal.content')}
                            </Typography>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Grid container item xs={12} justifyContent={isSuccess ? "space-between" : "flex-end"}>
                        {isSuccess ?
                            <Grid item xs={3}>
                                <Button fullWidth variant={"text"} color={"accent"} onClick={() => { navigate("/pricing/product-code/location-group", {replace: true, state: {productCodeId: createdProductCode}}) }}>
                                    {t('salesmarketing:product.buttons.addPricing')}
                                </Button>
                            </Grid> : <Grid item xs={3}/>
                        }
                        <Grid item xs={3}>
                            <Button fullWidth color={"accent"} onClick={() => { navigate("/salesmarketing/productcodelist") }}>
                                {t('salesmarketing:product.buttons.close')}
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default ProductCodeCreateModal;